import { Component, Input } from '@angular/core';
import { Password } from '../../models/passwordmodel';
import { accountService }   from '../../services/account.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { AcctResponse } from '../../models/accountresponse';
import {Router} from  '@angular/router';

@Component({
  templateUrl: './change.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [accountService]
})

export class ChangeComponent {
  @Input() responseObj: Session;
  public data;
  public passObj : Password;
  public response: AcctResponse;
  errorMessage: string;
  public itemResource;
  items = [];
  itemCount = 0;


  constructor(public _accountService: accountService, public router: Router, public sharedservice: SharedService) {
    
  }

  ngOnInit()
  {   
      // call the method on initial load of page to bind dropdown           
      this.passObj = new Password();
      this.passObj.storeid = this.sharedservice.session.account_username;
  }

  changePassword(isValid: boolean){
    if(isValid){
      this._accountService.changePassword(this.passObj).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);      
    }
  }
  
  handleResponse(result){
    this.response = result;

    this.sharedservice.logout();
  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/account/change.component.ts